import React, { useRef, useState, useEffect } from "react";
import ErrorMessage from "components/ErrorMessage";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import useToastContext from "hooks/useToastContext";
import OFile from "components/reusable/OFile";
import { validationRules } from "utils/constants";
const ConsultationQueryView = () => {
  const { t } = useTranslation();
  let location = useLocation();
  const [date, setDate] = useState("");
  const [profilePicError, setProfilePicError] = useState("");
  const [is_redirect, setRedirect] = useState(false);
  const [profilePic, setProfilePic] = useState(location?.state?.file || null);
  const [addMerchantLoading, setAddMerchantLoading] = useState(false);
  const profilePicRef = useRef();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [editData, setEditData] = useState(location.state.item);
  const notification = useToastContext();
  const [uploadedImages, setUploadedImages] = useState(
    location?.state?.item?.images || null
  );
  const [uploadedAudio, setUploadedAudio] = useState(
    location?.state?.item?.audio || null
  );
  const {
    register,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    souldFocusError: true,
    defaultValues: {
      userName: location?.state?.item?.userName || "",
      userOccupation: (location?.state?.item?.userOccupation?.map((item) => item?.label)).join(', ') || "",
      category: location?.state?.item?.categoryDetails?.title || "",
      description: location?.state?.item?.description || "",
      status: location?.state?.item?.status || "",
      repliedDate: location?.state?.item?.repliedDate || "",
      reply: location?.state?.item?.reply || ""
    },
  });

  const getBack = () => {
    setRedirect(true);
    navigate("/consultation-manager");
  };

  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        {/* <h2 className="font-medium text-black dark:text-white mb-3 text-xl">
          View C
        </h2> */}
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="userName"
                  id="userName"
                  disabled
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("userName")}
                />
                <label
                  htmlFor="userName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_USER_NAME")}
                  
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="userOccupation"
                  id="userOccupation"
                  disabled
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("userOccupation")}
                />
                <label
                  htmlFor="userOccupation"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_USER_TYPE")}
                  
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  disabled
                  name="category"
                  id="category"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("category")}
                />
                <label
                  htmlFor="category"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_CATEGORY")}                 
                </label>
              </div>
            </div>
            <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                disabled
                  type="text"
                  name="description"
                  id="description"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={151}
                  {...register("description")}
                />
                <label
                  htmlFor="description"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_DESCRIPTION")}
                  
                </label>
              </div>
            </div>
            {location?.state?.item?.status === 'replied' && <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                disabled
                  type="text"
                  name="reply"
                  id="reply"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={151}
                  {...register("reply")}
                />
                <label
                  htmlFor="description"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_REPLY")}
                  
                </label>
              </div>
            </div>}

            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                type="button"
                onClick={getBack}
              >
                {t("O_BACK")}
              </button>
            </div>
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
              <div className="mb-3">
                <div className="">
                  <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                    Uploaded Audio
                  </h3>
                </div>
            {uploadedAudio?.length > 0 ? (
                <div className="relative grid grid-cols-3 gap-3">
                  {uploadedAudio?.map((item, i) => {
                    return (
                      <div key={i}>
                        <a href={item?.url} target="_blank" rel="noreferrer">
                          <OFile
                            type={item?.type}
                            src={item?.url}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-48 h-48 border relative inline"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
            ) : "N/A"}
              </div>
              <div className="mb-3">
                <div className="">
                  <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                    Uploaded Images
                  </h3>
                </div>
            {uploadedImages?.length > 0 ? (
                <div className="relative grid grid-cols-3 gap-3">
                  {uploadedImages?.map((item, i) => {
                    return (
                      <div key={i}>
                        <a href={item?.url} target="_blank" rel="noreferrer">
                          <OFile
                            type={item?.type}
                            src={item?.url}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-48 h-48 border relative inline"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
            ) : "N/A"}
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationQueryView;
